import BlankLayout from '@/layouts/blank/BlankLayout.vue';
import SideLogin from '@/views/authentication/SideLogin.vue';
import type { RouteRecordRaw } from 'vue-router';
import { authRoutesName } from './routeName';
import { lazyWithRetry } from './routerUtils';


const AuthRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        component: BlankLayout,
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: '',
                redirect: { name: authRoutesName.login }
            },
            {
                name: authRoutesName.login,
                path: '/' + authRoutesName.login,
                component: SideLogin//() => import( '@/views/authentication/SideLogin.vue' )
            },
            /*
            {
                name: 'Side Register',
                path: '/auth/register',
                component: lazyWithRetry( () => import( '@/views/authentication/SideRegister.vue' )
            },*/
            {
                name: authRoutesName.forgotPassword,
                path: '/' + authRoutesName.forgotPassword,
                component: lazyWithRetry( () => import( '@/views/authentication/SideForgotPassword.vue' ) )
            },

            {
                name: authRoutesName.verifyEmail,
                path: '/' + authRoutesName.verifyEmail,
                component: lazyWithRetry( () => import( '@/views/authentication/SideVerifyEmail.vue' ) )
            },

            {
                name: 'Error',
                path: '/404',
                component: lazyWithRetry( () => import( '@/views/authentication/Error.vue' ) )
            },
            {
                name: authRoutesName.maintenance,
                path: '/maintenance',
                component: lazyWithRetry( () => import( '@/views/authentication/Maintenance.vue' ) )
            },
            {
                name: authRoutesName.error,
                path: '/:pathMatch(.*)*',
                component: lazyWithRetry( () => import( '@/views/authentication/Error.vue' ) )
            },
            {
                name: authRoutesName.notAuthorized,
                path: '/' + authRoutesName.notAuthorized,
                component: lazyWithRetry( () => import( '@/views/authentication/NotAuthorized.vue' ) )
            },
            {
                name: authRoutesName.logout,
                path: '/' + authRoutesName.logout,
                component: lazyWithRetry( () => import( '@/views/authentication/Logout.vue' ) )
            }
        ]
    }
];

export default AuthRoutes;
export { authRoutesName };

